<template>
  <div>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <DeleteModal
      :show="deleteModal"
      @close="deleteModal = false"
      @submit="doPause"
      :name="$t('device_transmission')"
      :msg="$t('pause_text')"
      :action="$t('pause')"
      :isDevicesRoute="true"
      buttonClass="btn-primary"
    />

    <ConfirmModal
      :msg="$t('start_text')"
      :show="showConfirm"
      @close="showConfirm = false"
      @submit="doStart"
      :heading="$t('start_transmission')"
      :btnTxt="$t('yes_start')"
      is-yellow
      msgWidth="msg_width"
    />

    <SuccessModal
      :show="showSuccessPopup"
      @close="closeSuccess"
      :msg="successMsg"
      :heading="successHeading"
      msgWidth="msg_width"
    />

    <div class="table-responsive">
      <div
        id="zero_config_wrapper"
        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
      >
        <div class="row mb-2">
          <div class="col-sm-12 col-md-12">
            <div class="d-flex align-items-center justify-content-between">
              <select
                class="form-control"
                name="condition"
                v-model="condition"
                @change="sortDevices"
                style="width: 14rem"
              >
                <option value="all">{{ $t("all-devices") }}</option>
                <option value="stable">{{ $t("stable") }}</option>
                <option value="critical">{{ $t("critical") }}</option>
              </select>
              <TableSearch :left="'left:18px'" @handleSearch="handleSearch" />
            </div>
          </div>
        </div>
        <div class="row" style="height: 22rem; overflow: auto">
          <div class="col-sm-12">
            <table id="zero_config" class="table table-hover">
              <thead class="data-table-bg">
                <tr>
                  <th
                    :key="index"
                    v-for="(column, index) in tableColumns"
                    @click="sortBy(column[1])"
                    style="cursor: pointer; text-align: left"
                  >
                    {{ column[0] }}
                    <span
                      class="arrow"
                      :class="sortOrders[column[1]] > 0 ? 'asc' : 'dsc'"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody v-if="this.stats.length !== 0 && this.dataCheck">
                <tr
                  :key="index"
                  v-for="(data, index) in paginatedData"
                  @click="gotodevice(data.id)"
                  style="cursor: pointer; text-align: left"
                  :class="{
                    'data-table-bg': index % 2 !== 0,
                  }"
                >
                  <td>
                    <div
                      style="display: flex; justify-content: left"
                      class="pt-2"
                    >
                      <div
                        v-if="!data.column1"
                        style="
                          height: 0.8rem;
                          width: 0.8rem;
                          border-radius: 0.4rem;
                        "
                        class="bg-secondary"
                      ></div>
                      <div
                        v-else-if="data.date && data.column1 === 'stable'"
                        style="
                          height: 0.8rem;
                          width: 0.8rem;
                          border-radius: 0.4rem;
                        "
                        class="bg-success"
                      ></div>
                      <div
                        v-else
                        style="
                          height: 0.8rem;
                          width: 0.8rem;
                          border-radius: 0.4rem;
                        "
                        class="bg-danger"
                      ></div>
                    </div>
                  </td>
                  <td>{{ data.column2 }}</td>
                  <td>{{ data.column3 }}</td>
                  <td>{{ data.column4 }}</td>
                  <td v-if="data.date">
                    {{ data.column5 }}
                  </td>
                  <!-- <td v-else-if="data.date && !data.subscription">
                  -
                </td> -->
                  <td v-else>
                    {{ $t("no-read") }}
                  </td>
                  <td v-if="data.date">
                    {{ data.column6 }}
                  </td>
                  <!-- <td v-else-if="data.date && !data.subscription">
                  -
                </td> -->
                  <td v-else>
                    {{ $t("no-read") }}
                  </td>
                  <td v-if="data.date">{{ data.column7 }}</td>
                  <td v-else>
                    {{ $t("no-read") }}
                  </td>
                  <td v-if="data.date">{{ data.date }}</td>
                  <!-- <td v-else-if="data.date && !data.subscription">
                  -
                </td> -->
                  <td v-else>
                    {{ $t("no-read") }}
                  </td>
                  <td style="display: flex; gap: 1rem">
                    <!-- <span
                      v-if="!data.isTransmissionEnabled"
                      @click.stop="startTransmission(data.id, data.column4)"
                    >
                      <PlayIcon />
                    </span>
                    <span
                      v-else
                      @click.stop="showDeleteModal(data.id, data.column4)"
                    >
                      <PauseIcon />
                    </span> -->
                    <div @click.stop="">
                      <toggle-button
                        :value="data.isTransmissionEnabled"
                        :color="'#6282C4'"
                        sync
                        @change="
                          (e) => handleTransmission(e, data.id, data.column4)
                        "
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else-if="this.stats.length !== 0 && !this.dataCheck">
                <tr>
                  <td colspan="6">
                    {{ $t("no-search") }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">
                    {{ $t("no-dev") }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <PaginationNew
          :pageCount="pageCount"
          :data="paginatedData"
          :sizeperpage="sizeperpage"
          :pageNumber="pageNumber"
          :pages="pages"
          @goToLastPage="goToLastPage"
          @nextPage="nextPage"
          @handlePageChange="handlePageChange"
          @goToFirstPage="goToFirstPage"
          @prevPage="prevPage"
          @onchange="onchange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import tableMixin from "../mixins/tableMixinWithBackend";
import TableSearch from "./TableSearch.vue";
import PaginationNew from "./PaginationNew.vue";

import PauseIcon from "../components/Iconsvg/PauseIcon.vue";
import PlayIcon from "../components/Iconsvg/PlayIcon.vue";

import DeleteModal from "../views/Modals/DeleteModal.vue";
import SuccessModal from "../views/Modals/SuccessModal.vue";

import ConfirmModal from "../views/Modals/ConfirmModal.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { ToggleButton } from "vue-js-toggle-button";

export default {
  name: "Table",
  components: {
    TableSearch,
    PaginationNew,
    PauseIcon,
    PlayIcon,
    DeleteModal,
    SuccessModal,
    ConfirmModal,
    Loading,
    ToggleButton,
  },
  props: {
    stats: Array,
    paginationMeta: Object,
  },
  data() {
    return {
      dataTable: [],
      dataCheck: true,
      condition: "all",
      deleteModal: false,
      showSuccessPopup: false,
      showConfirm: false,
      successMsg: "",
      successHeading: "",
      deviceId: "",
      deviceName: "",
      isLoading: false,
      fullPage: true,
    };
  },

  watch: {
    stats: {
      handler: function () {
        this.dataTable = [];
        for (const element of this.stats) {
          let lastseen;
          if (element?.stat?.deviceTimeStamp) {
            let dDate = element?.stat?.deviceTimeStamp;
            lastseen = moment(dDate).format("MMM Do YYYY, hh:mm a");
          } else {
            lastseen = "";
          }

          let status;
          let temperature;
          let humidity;
          let dateOrig;
          if (!lastseen) {
            status = "";
            temperature = Number.NEGATIVE_INFINITY;
            humidity = Number.NEGATIVE_INFINITY;
            dateOrig = "";
          } else {
            status = element.status;
            temperature = element.stat.temperature;
            humidity = element.stat.humidity;
            dateOrig = element.stat.createdAt;
          }
          let id = element.id;
          let date = element.createdAt;
          date = moment(date, "x", true).format("MMM Do YYYY, hh:mm a");
          this.dataTable.push({
            column1: status,
            column2: element.deviceTag,
            column3: element.imei,
            column4: element.settings.name,
            column5: temperature,
            column6: humidity,
            column7: element?.stat?.battery || 0,
            dateOrig,
            date: lastseen,
            id,
            subscription: !element.subscription
              ? false
              : element.subscription.active,
            isTransmissionEnabled: element?.isTransmissionEnabled ?? true,
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(["lastPageData", "getCondition"]),
    tableColumns() {
      return [
        [this.$t("stat"), "column1"],
        [this.$t("dev-tag"), "column2"],
        ["Imei", "column3"],
        [this.$t("dev-name"), "column4"],
        [this.$t("temp", { name: "(°C)" }), "column5"],
        [this.$t("humid", { name: "(%)" }), "column6"],
        [this.$t("batt", { name: "(%)" }), "column7"],
        [this.$t("last-seen"), "dateOrig"],
        [this.$t("transmission"), "isTransmissionEnabled"],
      ];
    },
  },
  mixins: [tableMixin],
  methods: {
    ...mapActions(["updatePageNumber", "updateDevice"]),
    gotodevice(deviceTag) {
      this.$router.push(`/devices/${deviceTag}/details`);
      this.updatePageNumber({
        lastPageNumber: this.pageNumber,
        lastPage: `/devices/${deviceTag}/details`,
        lastPageName: "device",
        lastPageLink: "/devices",
      });
    },
    sortDevices({ target: { value } }) {
      this.$emit("sortByStatus", {
        status: value === "all" ? undefined : [value],
        ...this.params,
        keyword: this.searchQuery,
        filterOperator: "and",
      });
    },
    showDeleteModal(id, name) {
      this.deviceId = id;
      this.deviceName = name;
      this.deleteModal = true;
    },
    doPause() {
      this.isLoading = true;
      this.updateDevice({
        device_id: this.deviceId,
        deviceupdate: {
          name: this.deviceName,
          isTransmissionEnabled: false,
        },
      })
        .then(() => {
          this.isLoading = false;
          this.deleteModal = false;
          this.successHeading = this.$t("pause_heading");
          this.successMsg = this.$t("pause_msg");
          this.showSuccess();
          this.$emit("fetchDevices", { ...this.params });
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    doStart() {
      this.isLoading = true;
      this.updateDevice({
        device_id: this.deviceId,
        deviceupdate: {
          name: this.deviceName,
          isTransmissionEnabled: true,
        },
      })
        .then(() => {
          this.isLoading = false;
          this.successMsg = this.$t("start_msg");
          this.successHeading = this.$t("start_heading");
          this.showConfirm = false;
          this.showSuccess();
          this.$emit("fetchDevices", { ...this.params });
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    startTransmission(id, name) {
      this.deviceId = id;
      this.deviceName = name;
      this.showConfirm = true;
    },
    showSuccess() {
      this.showSuccessPopup = true;
    },
    closeSuccess() {
      this.showSuccessPopup = false;
      this.deviceId = "";
      this.deviceName = "";
    },
    handleTransmission({ value }, id, name) {
      this.toggleValue = value;
      if (value) {
        this.startTransmission(id, name);
      } else {
        this.showDeleteModal(id, name);
      }
    },
  },
  mounted() {
    this.pageNumber = this.lastPageData.lastPageNumber;

    this.condition = this.getCondition === "critical" ? "critical" : "all";
  },
};
</script>

<style scoped>
/* td {
  border-bottom: 1px rgba(0, 0, 0, 0.1) solid;
} */

th,
td {
  min-width: 120px;
}
th.active {
  color: #fff;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 8px solid #000000;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 8px solid #000000;
}

</style>

<i18n>
{
	"en": {
		"Search": "Search",
		"batt": "Battery {name}",
		"dev-name": "Device Name",
		"dev-tag": "Device Tag",
		"entries": "entries",
		"last-seen": "Last Seen",
		"next": "Next",
		"no-dev": "You have no devices yet",
		"no-read": "No readings yet",
		"no-search": "No search result found",
		"of": "of",
		"prev": "Previous",
		"readings": "readings",
		"show": "Show",
		"showing": "Showing",
		"stat": "Status",
		"temp": "Temperature {name}",
		"to": "to"
	},
	"es": {
		"Search": "Buscar",
		"batt": "Batería {name}",
		"dev-name": "Nombre del dispositivo",
		"dev-tag": "Etiqueta de dispositivo",
		"entries": "entradas",
		"last-seen": "Ultima vez visto",
		"next": "Siguiente",
		"no-dev": "Aún no tienes dispositivos",
		"no-read": "Aún no hay lecturas",
		"no-search": "No se encontraron resultados de búsqueda",
		"of": "de",
		"prev": "Anterior",
		"readings": "Lecturas",
		"show": "Show",
		"showing": "Demostración",
		"stat": "Estado",
		"temp": "Temperatura {name}",
		"to": "a"
	},
	"fr": {
		"Search": "Chercher",
		"batt": "Batterie {name}",
		"dev-name": "Nom de l'appareil",
		"dev-tag": "Balise d'appareil",
		"entries": "Les entrées",
		"last-seen": "Vue la dernière fois",
		"next": "Suivant",
		"no-dev": "Vous n'avez pas encore d'appareils",
		"no-read": "Pas encore de lectures",
		"no-search": "Aucun résultat de recherche trouvé",
		"of": "De",
		"prev": "précédent",
		"readings": "Lectures",
		"show": "Spectacle",
		"showing": "Montrant",
		"stat": "Statut",
		"temp": "Température {name}",
		"to": "à"
	},
	"sw": {
		"Search": "Tafuta",
		"batt": "Betri {name}",
		"dev-name": "Jina la kifaa",
		"dev-tag": "Lebo ya Kifaa",
		"entries": "Viingilio",
		"last-seen": "Mara ya mwisho kuonekana",
		"next": "Ifuatayo",
		"no-dev": "Bado huna vifaa",
		"no-read": "Bado hakuna masomo",
		"no-search": "Hakuna matokeo ya utafutaji yaliyopatikana",
		"of": "ya",
		"prev": "Hapo awali",
		"readings": "usomaji",
		"show": "Onyesha",
		"showing": "Kuonesha",
		"stat": "Hali",
		"temp": "Halijoto {name}",
		"to": "Kwa"
	}
}
</i18n>
